import { ChangeEvent, useState } from "react";
import styled from "styled-components";

import Label from "../Label";
import { FieldHint } from "../styles";
import { fieldContainerCss, inputCss } from "./styles";

const BasicInput = styled.input`
  ${inputCss};
`;

type ContainerProps = {
  focus: boolean;
};

const Container = styled.div<ContainerProps>`
  ${fieldContainerCss};

  input {
    ${inputCss};
    margin: 0px;
    border: none;
    margin-left: -14px;
    font-weight: inherit;
    font-size: inherit;
    padding-right: 10px;
    margin-right: 10px;
    flex: 1;
    color: inherit;
    &:focus {
      outline: none;
    }

    ::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      /* color: var(--color-neutral-white); */
      color: var(--color-neutral-light);
      opacity: 0.7; /* Firefox */
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: var(--color-neutral-light);
      opacity: 0.7; /* Firefox */
    }

    ::-ms-input-placeholder {
      /* Microsoft Edge */
      color: var(--color-neutral-light);
      opacity: 0.7; /* Firefox */
    }
  }

  span {
    color: var(--color-neutral-light);
  }

  &.no-value svg {
    path:nth-child(1) {
      fill: var(--color-neutral-light);
    }
    path:nth-child(2) {
      fill: #020202;
    }
    path:nth-child(3) {
      fill: var(--color-neutral-light);
    }
  }
`;

type Props = {
  id: string;
  type: string;
  value?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  maxLength?: number;
  prefix?: string;
  sufix?: string;
  label: string;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  ignoreLengthInfo?: boolean;
  loading?: boolean;
  infoMessage?: string;
  autoFocus?: boolean;
  autoCapitalize?: string;
  icon?: React.ReactNode;
  ignoreNoValueIconClass?: boolean;
  input?: React.ReactNode;
  /** Help text under the field. */
  hint?: string;
};

const Input = ({
  id,
  type,
  value = "",
  onChange,
  maxLength,
  prefix,
  sufix,
  label,
  required,
  placeholder,
  disabled,
  ignoreLengthInfo,
  loading,
  infoMessage,
  autoFocus,
  autoCapitalize = "on",
  icon,
  ignoreNoValueIconClass,
  input,
  hint,
}: Props) => {
  const [focus, setFocus] = useState(false);

  return (
    <>
      <Container
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        focus={focus}
        className={!value && !ignoreNoValueIconClass ? "no-value" : ""}>
        {icon && icon}
        {prefix && <span>{prefix}</span>}
        {input ? (
          input
        ) : (
          <BasicInput
            autoFocus={autoFocus}
            id={id}
            name={id}
            type={type}
            value={value}
            onChange={onChange}
            maxLength={maxLength}
            autoCapitalize={autoCapitalize}
            spellCheck="false"
            autoComplete="off"
            disabled={disabled}
            placeholder={placeholder}
          />
        )}
        {sufix && <span className="mr-4">{sufix}</span>}
      </Container>
      <Label
        htmlFor={id}
        required={required}
        text={label}
        usedLength={value.length}
        maxLength={maxLength}
        loading={loading}
        ignoreLengthInfo={ignoreLengthInfo}
        infoMessage={infoMessage}
      />
      {hint && <FieldHint>{hint}</FieldHint>}
    </>
  );
};

export default Input;
